
define('text!modules/icons/icon_template.html',[],function () { return '<span class="sr"><%-name%></span>';});

